import { Component, OnInit, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Router } from '@angular/router';
import { Jwt, UserService } from '../services/api-services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { NotificationDialComponent } from '../utils/dialogues/notification-dial/notification-dial.component';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatButton],
})
export class LoginComponent implements OnInit {
  /** Inject services. */
  private readonly fb = inject(FormBuilder);
  private readonly userService = inject(UserService);
  private readonly router = inject(Router);
  private readonly dialogRef = inject(MatDialog);

  form: FormGroup;
  denied = false;
  errorMsg = '';

  constructor() {
    this.form = this.fb.group({
      usr: ['', Validators.required],
      pwd: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.redirectIfLoggedIn();
  }

  async login() {
    const val = this.form.value;

    if (val.usr && val.pwd) {
      const res = await this.userService.login(val.usr, val.pwd);
      this.verifyLogin(res);
      this.form.controls['pwd'].setValue('');
    }
  }

  verifyLogin(result: Jwt): void {
    if (result.success) {
      if (result.needPwdChange) {
        const ref = this.dialogRef.open(NotificationDialComponent, {
          maxHeight: '600px',
          width: '600px',
          data: {
            title: 'Change Password',
            message:
              'Your current password was for one-time use only. Please update it now to ensure permanent access to your account for Hephaestus.',
          },
        });
        ref.afterClosed().subscribe(() => this.redirectIfLoggedIn());
      } else {
        this.redirectIfLoggedIn();
      }
    } else {
      this.denied = true;
      this.errorMsg = result.msg;
    }
  }

  redirectIfLoggedIn() {
    if (this.userService.isAuthenticated()) {
      void this.router.navigate(['/dashboard']);
    }
  }
}
